export default "__VITE_ASSET__d923dcca__"